<template>
  <v-container fluid>
    <v-row>
      <v-col md="6">
        <v-toolbar flat density color="grey lighten-4">
          <v-toolbar-title class="mt-4">Edit Kit Configuration</v-toolbar-title>
        </v-toolbar>
      </v-col>
      <v-col md="6" class="text-right">
        <router-link :to="{ name: 'listKitMapping' }">
          <v-btn
            rounded
            v-if="$vuetify.breakpoint.smAndUp"
            class="mt-4 black--text"
            elevation="0"
          >
            <v-icon left>mdi-chevron-left</v-icon>Back
          </v-btn>
          <v-btn
            v-else
            fixed
            right
            small
            rounded
            fab
            color="grey lighten-4"
            elevation="2"
            class="mr-2 mt-4"
            style="opacity: 0.8"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card-component>
          <v-row>
            <v-col cols="12" md="3" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">Kit Type</div>
                  <div
                    class="text-button mb-1"
                    v-text="kitSetMapData.kitName"
                  ></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">Class</div>
                  <div
                    class="text-button mb-1"
                    v-text="kitSetMapData.class"
                  ></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <div class="d-flex justify-space-between caption">
                <div>
                  <div class="grey--text text-subtitle-2 mb-1">Set Name</div>
                  <div
                    class="text-button mb-1"
                    v-text="kitSetMapData.setName"
                  ></div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="12" lg="12" sm="12" xs="12">
              <v-data-table
                disable-pagination
                :hide-default-footer="true"
                :headers="kitHeader"
                :items="kitJsonData"
              >
                <template v-slot:item.FCID="{ item }">
                  <v-text-field
                    :class="{
                      'mr-0 my-1': $vuetify.breakpoint.xs,
                      'mr-5': $vuetify.breakpoint.smAndUp
                    }"
                    v-model="item.FCID"
                    hide-details="true"
                    label="FCID"
                    type="number"
                    dense
                    single-line
                    :style="
                      $vuetify.breakpoint.xs ? 'width:150px' : 'width:auto;'
                    "
                  />
                </template>
                <template v-slot:item.quantity="{ item }">
                  <v-text-field
                    :class="{
                      'mr-0 my-1': $vuetify.breakpoint.xs,
                      'mr-5': $vuetify.breakpoint.smAndUp
                    }"
                    v-model="item.quantity"
                    hide-details="true"
                    label="Quantity"
                    type="number"
                    dense
                    single-line
                    :style="
                      $vuetify.breakpoint.xs ? 'width:150px' : 'width:auto;'
                    "
                  />
                </template>
                <template v-slot:item.isMandatory="{ item }">
                  <v-autocomplete
                    :class="{
                      'mr-0 my-1': $vuetify.breakpoint.xs,
                      'mr-5': $vuetify.breakpoint.smAndUp
                    }"
                    v-model="item.isMandatory"
                    :items="isMandatory"
                    label="isMandatory"
                    dense
                    single-line
                    hide-details="true"
                    :style="
                      $vuetify.breakpoint.xs ? 'width:150px' : 'width:auto;'
                    "
                  ></v-autocomplete>
                </template>
                <template v-slot:item.alternateFcid1="{ item }">
                  <v-text-field
                    :class="{
                      'mr-0 my-1': $vuetify.breakpoint.xs,
                      'mr-5': $vuetify.breakpoint.smAndUp
                    }"
                    v-model="item.alternateFcid1"
                    hide-details="true"
                    label="Aleternate FCID 1"
                    type="number"
                    dense
                    single-line
                    :style="
                      $vuetify.breakpoint.xs ? 'width:150px' : 'width:auto;'
                    "
                  />
                </template>
                <template v-slot:item.alternateFcid2="{ item }">
                  <v-text-field
                    :class="{
                      'mr-0 my-1': $vuetify.breakpoint.xs,
                      'mr-5': $vuetify.breakpoint.smAndUp
                    }"
                    v-model="item.alternateFcid2"
                    hide-details="true"
                    label="Aleternate FCID 2"
                    type="number"
                    dense
                    single-line
                    :style="
                      $vuetify.breakpoint.xs ? 'width:150px' : 'width:auto;'
                    "
                  />
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn
                    class="mr-1"
                    outlined
                    small
                    dense
                    color="success"
                    elevation="0"
                    @click="saveSingleKitData(item)"
                  >
                    save
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-component>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import VCardComponent from '@/components/template/VCardComponent.vue'
import constants from '@/utils/constants'
import _ from 'lodash'
export default {
  name: 'edituploadkit',
  props: ['kitMapId'],
  components: {
    VCardComponent
  },
  data () {
    return {
      constantKit: _.filter(
        constants.KIT,
        (obj) => obj.isDisplayOnMapping === true
      ),
      kitSetMapData: {
        kitName: '',
        class: '',
        setName: ''
      },
      kitHeader: [
        { text: 'FCID', value: 'FCID' },
        { text: 'Quantity', value: 'quantity' },
        { text: 'isMandatory', value: 'isMandatory' },
        { text: 'Alternate FCID 1', value: 'alternateFcid1' },
        { text: 'Alternate FCID 2', value: 'alternateFcid2' },
        { text: 'Action', value: 'actions', align: 'center' }
      ],
      isMandatory: [
        { text: 'Yes', value: 'Yes' },
        { text: 'No', value: 'No' }
      ],
      kitJsonData: []
    }
  },
  created: async function () {
    this.getKitData()
  },
  methods: {
    getKitData: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/kitSetMapping/get-kitSet-products/${this.kitMapId}`
        )
        if (response.status === 200) {
          if (typeof response.data.kitSetMap !== 'undefined') {
            this.kitSetMapData.kitName = response.data.kitSetMap.kit.name
            this.kitSetMapData.class = response.data.kitSetMap.studentClass.name
            this.kitSetMapData.setName = response.data.kitSetMap.name
          }
          if (typeof response.data.kitSetProducts !== 'undefined') {
            _.forEach(response.data.kitSetProducts, (item) => {
              this.kitJsonData.push({
                kitProductMapID: item.id,
                FCID: item.productID,
                quantity: item.quantity,
                isMandatory: item.isMandatory ? 'Yes' : 'No',
                alternateFcid1: item.altProductID1,
                alternateFcid2: item.altProductID2
              })
            })
          }
        } else {
          return this.$dialog.error({
            title: 'No data available',
            text: 'Data not available'
          })
        }
      } catch (e) {
        const errorTitle = (e && e.response && e.response.data.error) || e.error
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          title: errorTitle,
          text: errorMessage
        })
      }
    },
    saveSingleKitData: async function (obj) {
      try {
        // Add Validation For obj data
        let payload = {}
        if (obj.FCID === '' || obj.FCID <= 0) {
          return this.$dialog.error({
            title: 'Error with FCID',
            text: 'FCID should not be empty'
          })
        } else if (obj.quantity === '' || obj.quantity <= 0) {
          return this.$dialog.error({
            title: 'Error with Quantity',
            text: 'Quantity should not be empty and should be greater then 0.'
          })
        } else if (
          (obj.alternateFcid1 === obj.FCID ||
            obj.alternateFcid1 === obj.alternateFcid2) &&
          obj.alternateFcid1 !== '' &&
          obj.alternateFcid1 !== null
        ) {
          return this.$dialog.error({
            title: 'Error with Alternate FCID 1',
            text: 'Alternate FCID 1 not be equal to FCID or Alternate FCID 2'
          })
        } else if (
          (obj.alternateFcid2 === obj.FCID ||
            obj.alternateFcid2 === obj.alternateFcid1) &&
          obj.alternateFcid2 !== '' &&
          obj.alternateFcid2 !== null
        ) {
          return this.$dialog.error({
            title: 'Error with Alternate FCID 2',
            text: 'Alternate FCID 2 not be equal to FCID or Alternate FCID 1'
          })
        }

        // Creating Payload for update product map
        payload.kitProductMapID = Number(obj.kitProductMapID)
        payload.FCID = Number(obj.FCID)
        payload.quantity = Number(obj.quantity)
        payload.isMandatory = obj.isMandatory
        payload.alternateFCID1 = Number(obj.alternateFcid1)
        payload.alternateFCID2 = Number(obj.alternateFcid2)
        await http
          .post(
            `${constants.API_URL}/api/kitSetMapping/update-product-map`,
            payload
          )
          .then((res) => {
            if (res.status === 200) {
              this.$dialog.message.info(res.data.message, {
                position: 'top-center',
                color: 'success',
                timeout: 4000
              })
            } else {
              this.$dialog.message.info(res.data.message, {
                position: 'top-center',
                color: 'error',
                timeout: 4000
              })
            }
          })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.$dialog.message.info(errorMessage, {
          outlined: true,
          position: 'top-center',
          color: 'error',
          timeout: 4000
        })
      }
    }
  }
}
</script>
